export {
  BOTShopForTiresHeader,
  BOTShopTeaser,
  BOTShopForTiresUserHtml,
  BOTShopForTires,
  BOTShopByBrandMessage
} from '../TiresLanding'
